import React, {useState, useEffect, useCallback, useRef} from 'react'
import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {useIntl} from 'react-intl'
import {getApplicationUser} from '../../../../../pages/applicationuser/list/core/_requests'
import {Model} from '../../../../../pages/applicationuser/list/core/_models'
import clsx from 'clsx'
import {getCountry as listCountry} from '../../../../../pages/country/list/core/_requests'
import {getCode as listGender} from '../../../../../pages/code/list/core/_requests'
import {getCode as listMaritalStatus} from '../../../../../pages/code/list/core/_requests'
import {getDiplomaAvarageType as listDiplomaAvarageType} from '../../../../../pages/diplomaavaragetype/list/core/_requests'
import {useDropzone} from 'react-dropzone'
import axios, {AxiosResponse} from 'axios'
import moment from 'moment'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert2'
import {useAuth} from '../../../../auth/core/Auth'
import * as EXIF from 'exif-js'
import {useLang} from '../../../../../../_metronic/i18n/Metronici18n'
import {getCode as listInternationDocType} from '../../../../../pages/code/list/core/_requests'

const API_URL = process.env.REACT_APP_API_URL?.replace('/api', '/Files/')
const API_URL_REAL = process.env.REACT_APP_API_URL

const ProfileDetails: React.FC = () => {
  const intl = useIntl()
  const lang = useLang()
  const [data, setData] = useState<Model>()
  const [previewSrc, setPreviewSrc] = useState('') // Add this state to keep track of the preview URL
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [diplomaavaragetypes, setdiplomaavaragetypes] = React.useState([])
  const [loading, setLoading] = useState(false)
  const [countrys, setcountrys] = React.useState([])
  const [genders, setgenders] = React.useState([])
  const [maritalStatus, setMaritalStatus] = React.useState([])
  const navigate = useNavigate()
  const {logout, currentUser, setCurrentUser} = useAuth()
  const [isImageUplouded, setIsImageUplouded] = React.useState(false)
  const [RejectFile, setRejectFile] = useState<File | null>(null)
  const [internationalDocTypes, setInternationalDocTypes] = React.useState([])

  const profileDetailsSchema = Yup.object().shape({
    name: Yup.string()
      .required(intl.formatMessage({id: 'First_name_is_required'}))
      .nullable(),
    surname: Yup.string()
      .required(intl.formatMessage({id: 'Last_name_is_required'}))
      .nullable(),
    mothersName: Yup.string()
      .required(intl.formatMessage({id: 'Mother name is required'}))
      .nullable(),
    fathersName: Yup.string()
      .required(intl.formatMessage({id: 'Father name is required'}))
      .nullable(),
    // passportNumber: Yup.string().required(intl.formatMessage({ id: 'Passoport num is required' })).nullable(),
    // identity: Yup.string().required(intl.formatMessage({ id: 'Identity is required' })).nullable(),
    birthDate: Yup.string()
      .required(intl.formatMessage({id: 'Birthday is required'}))
      .nullable(),
    birthPlace: Yup.string()
      .required(intl.formatMessage({id: 'BirthPlace is required'}))
      .nullable(),
    // phone: Yup.string().required(intl.formatMessage({ id: 'Phone is required' })).nullable(),
    phone: Yup.string()
      .required(intl.formatMessage({id: 'Phone is required'}))
      .matches(
        /^((?!\+?90|90)\d*)$/,
        intl.formatMessage({id: 'Phone must not start with +90 or 90'})
      )
      .nullable(),
    address: Yup.string()
      .required(intl.formatMessage({id: 'Adress is required'}))
      .nullable(),
    countryId: Yup.number()
      .required(intl.formatMessage({id: 'countryId is required'}))
      .nullable(),
    genderId: Yup.number()
      .required(intl.formatMessage({id: 'gender is required'}))
      .nullable(),
    highSchoolName: Yup.string()
      .required(intl.formatMessage({id: 'highSchoolName is required'}))
      .nullable(),
    highSchoolType: Yup.string()
      .required(intl.formatMessage({id: 'HighSchoolType is required'}))
      .nullable(),
    highSchoolCity: Yup.string()
      .required(intl.formatMessage({id: 'highSchoolCity is required'}))
      .nullable(),
    highSchoolStartDate: Yup.string()
      .required(intl.formatMessage({id: 'highSchoolStartDate is required'}))
      .nullable(),
    highSchoolFinishDate: Yup.string()
      .required(intl.formatMessage({id: 'highSchoolEndDate is required'}))
      .nullable(),
    highSchoolCountryId: Yup.number()
      .required(intl.formatMessage({id: 'highSchoolCountryId is required'}))
      .nullable(),
    diplomaAvarage: Yup.number()
      .required(intl.formatMessage({id: 'diploma average is required'}))
      .nullable(),
    diplomaAvarageTypeId: Yup.number()
      .required(intl.formatMessage({id: 'diploma average type is required'}))
      .nullable(),
    maritalStatusId: Yup.number()
      .required(intl.formatMessage({id: 'maritalStatus is required'}))
      .nullable(),
    birthPlaceCountryId: Yup.number()
      .required(intl.formatMessage({id: 'birthPlaceCountryId is required'}))
      .nullable(),
    // internationalDocTypeId: Yup.number()
    //   .required(intl.formatMessage({id: 'internationalDocType is required'}))
    //   .nullable(),
  })

  // const fileSelectedHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
  //     if (event.target.files) {
  //         setSelectedFile(event.target.files[0]);
  //     }
  // };

  const fileSelectedHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const fileExtension = event?.target?.files[0]?.name.split('.').pop()?.toLowerCase()

      if (fileExtension !== 'jpg') {
        swal.fire({
          title: intl.formatMessage({
            id: 'Error',
          }),
          text: intl.formatMessage({id: 'Swal_Wrong_Format_jpg'}),
          icon: 'error',
          confirmButtonText: intl.formatMessage({id: 'Okay'}),
        })
        return
      }
      setSelectedFile(event.target.files[0])
    }
  }

  const rejectFileSelectedHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const fileExtension = event?.target?.files[0]?.name.split('.').pop()?.toLowerCase()
      if (fileExtension !== 'pdf') {
        swal.fire({
          title: intl.formatMessage({
            id: 'Error',
          }),
          text: intl.formatMessage({id: 'Swal_Wrong_Format_PDF'}),
          icon: 'error',
          confirmButtonText: intl.formatMessage({id: 'Okay'}),
        })
        return
      }
      setRejectFile(event.target.files[0])
    }
  }

  const fileUploadHandler = async () => {
    if (selectedFile) {
      const formData = new FormData()
      formData.append('file', selectedFile, selectedFile?.name)

      await axios.post(`${API_URL_REAL}/Custom/uploadid`, formData).then(async (response) => {
        navigate('/exam/uploadconfirmation')
      })
    }
  }
  const onDrop = useCallback(async (acceptedFiles: File[]) => {
    const file = acceptedFiles[0]
    const fileExtension = file?.name?.split('.')?.pop()?.toLowerCase()

    if (fileExtension !== 'jpg' || !file || file == undefined) {
      swal.fire({
        title: intl.formatMessage({
          id: 'Error',
        }),
        text: intl.formatMessage({id: 'Swal_Wrong_Format_jpg'}),
        icon: 'error',
        confirmButtonText: intl.formatMessage({id: 'Okay'}),
      })
      return
    }

    const reader = new FileReader()

    reader.onload = async function (e) {
      const img = new Image()
      img.src = e.target?.result as string

      img.onload = async function () {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        EXIF.getData(img, async function () {
          const orientation = EXIF.getTag(img, 'Orientation')
          let width = img.width
          let height = img.height

          if (orientation === 6 || orientation === 8) {
            canvas.width = height
            canvas.height = width
          } else {
            canvas.width = width
            canvas.height = height
          }

          if (ctx) {
            switch (orientation) {
              case 2:
                ctx.transform(-1, 0, 0, 1, width, 0)
                break
              case 3:
                ctx.transform(-1, 0, 0, -1, width, height)
                break
              case 4:
                ctx.transform(1, 0, 0, -1, 0, height)
                break
              case 5:
                ctx.transform(0, 1, 1, 0, 0, 0)
                break
              case 6:
                ctx.transform(0, 1, -1, 0, height, 0)
                break
              case 7:
                ctx.transform(0, -1, -1, 0, height, width)
                break
              case 8:
                ctx.transform(0, -1, 1, 0, 0, width)
                break
              default:
                ctx.transform(1, 0, 0, 1, 0, 0)
            }

            ctx.drawImage(img, 0, 0)

            canvas.toBlob(async function (blob) {
              const formData = new FormData()
              formData.append('avatar', blob as Blob, file?.name)

              try {
                const response = await axios.post(`${API_URL_REAL}/Custom/UploadAvatar`, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                  },
                })

                const dats = response.data
                const url =
                  dats?.id !== null
                    ? (API_URL || '') + ('avatar_' + dats?.id || '') + ('.jpg?ver=' + rasgeleSayi())
                    : '/media/avatars/blank.png'

                setPreviewSrc(url)
                setIsImageUplouded(true)
              } catch (error) {
                console.error('Error uploading image:', error)
              }
            })
          }
        })
      }
    }

    reader.readAsDataURL(file)
  }, [])

  useEffect(() => {
    getApplicationUser(
      'isonlyuserrecords=true',
      'Id,Name,Surname,Email,BirthDate,BirthPlace,HighSchoolName,HighSchoolCountryId,HighSchoolCity,HighSchoolType,HighSchoolStartDate,HighSchoolFinishDate,DiplomaAvarage,DiplomaAvarageTypeId,Phone,Address,PassportNumber,PassportCountryId,BirthPlaceCountryId,PassportIssueDate,PassportIssuingAuthority,PassportExpirationDate,BlueCardIssueDate,NationalIdNumber,Identity,PhotoFileName,EmailConfirmed,MothersName,FathersName,CountryId,Country.Name as Country,GenderId,Gender.Name as Gender,InternationalDocumentTypeId,InternationalDocumentType.Name as InternationalDocumentType, MaritalStatusId,MaritalStatus.Name as MaritalStatus,YosPlacementStatusId,YosPlacementStatus.Name as YosPlacementStatus',
      'Country,Gender,MaritalStatus'
    ).then((res: any) => {
      setData(res.data[0])
      formik.setValues({
        ...formik.values,
        ...res.data[0],
      })
      const url =
        res.data[0]?.id !== null
          ? (API_URL || '') + ('avatar_' + res.data[0]?.id || '') + ('.jpg?ver=' + rasgeleSayi())
          : '/media/avatars/blank.png'

      setPreviewSrc(url)
    })

    listCountry('sort=Name&items_per_page=9999', 'Id,Name,NameEn').then((res: any) => {
      setcountrys(res.data || [])
    })

    listGender('filter_TypeString=cinsiyet', 'Id,Name,NameEn').then((res: any) => {
      setgenders(res.data || [])
    })

    listInternationDocType('filter_TypeString=yabanciogrencibelgeturu', 'Id,Name,NameEn').then(
      (res: any) => {
        setInternationalDocTypes(res.data || [])
      }
    )

    listMaritalStatus('filter_TypeString=medenidurum', 'Id,Name,NameEn').then((res: any) => {
      setMaritalStatus(res.data || [])
    })

    listDiplomaAvarageType(
      'sort=Name&items_per_page=9999',
      'Id,Name,NameEn,MaxPoints,MinPoints,Increasing'
    ).then((res: any) => {
      setdiplomaavaragetypes(res.data || [])
    })
  }, [])

  function rasgeleSayi() {
    let min = 100000 // En küçük 6 basamaklı sayı
    let max = 999999 // En büyük 6 basamaklı sayı
    let rasgele = Math.floor(Math.random() * (max - min + 1)) + min
    return rasgele.toString()
  }

  const convertToCommaSeparated = (value: any) => {
    return value.toString().replace('.', ',')
  }

  const formik = useFormik<Model>({
    initialValues: {
      name: undefined,
      surname: undefined,
      email: undefined,
      password: undefined,
      mothersName: undefined,
      fathersName: undefined,
      countryId: undefined,
      genderId: undefined,
      passportNumber: undefined,
      identity: undefined,
      birthDate: new Date(),
      birthPlace: undefined,
      address: undefined,
      phone: undefined,
      diplomaAvarage: undefined,
      diplomaAvarageTypeId: undefined,
      highSchoolName: undefined,
      highSchoolCountryId: undefined,
      highSchoolStartDate: undefined,
      highSchoolFinishDate: undefined,
      highSchoolType: undefined,
      highSchoolCity: undefined,
      passportCountryId: undefined,
      passportIssueDate: undefined,
      passportIssuingAuthority: undefined,
      maritalStatusId: undefined,
      passportExpirationDate: undefined,
      blueCardIssueDate: undefined,
      //blueCardExpirationDate: undefined,
      nationalIdNumber: undefined,
      birthPlaceCountryId: undefined,
      internationalDocumentTypeId: undefined,
    },
    validationSchema: profileDetailsSchema,
    onSubmit: async (values) => {
      console.log('ONSUBMIT ÇALIŞTI')
      console.log(values)

      values.country = undefined
      values.gender = undefined
      //values.internationalDocumentType = undefined
      setLoading(true)
      try {
        if (!isImageUplouded) {
          swal
            .fire({
              title: intl.formatMessage({
                id: 'Error',
              }),
              text: intl.formatMessage({id: 'You_have_to_upload_Foto'}),
              icon: 'error',
              confirmButtonText: intl.formatMessage({id: 'Okay'}),
            })
            .then((result) => {})
          return
        }

        if (currentUser?.idApproved !== '1' && selectedFile === null) {
          swal
            .fire({
              title: intl.formatMessage({
                id: 'Error',
              }),
              text: intl.formatMessage({id: 'You have to upload your id document to proceed.'}),
              icon: 'error',
              confirmButtonText: intl.formatMessage({id: 'Okay'}),
            })
            .then((result) => {})
          return
        }

        if (currentUser?.isRejectFileRequired == 1 && RejectFile === null) {
          swal
            .fire({
              title: intl.formatMessage({
                id: 'Error',
              }),
              text: intl.formatMessage({id: 'UploadRejectFile'}),
              icon: 'error',
              confirmButtonText: intl.formatMessage({id: 'Okay'}),
            })
            .then((result) => {})
          return
        }

        if (!values.identity && !values.passportNumber) {
          swal.fire({
            title: intl.formatMessage({
              id: 'Error',
            }),
            text: intl.formatMessage({id: 'You_have_to_fill_identity_or_passportNumber'}),
            icon: 'error',
            confirmButtonText: intl.formatMessage({id: 'Okay'}),
          })
          return
        }

        const isError = diplomaavaragetypes.some((a: any) => {
          if (values.diplomaAvarage !== undefined && a.id == values.diplomaAvarageTypeId) {
            return values.diplomaAvarage < a.minPoints || values.diplomaAvarage > a.maxPoints
          }
        })

        //return;

        if (isError) {
          swal
            .fire({
              title: intl.formatMessage({
                id: 'Error',
              }),
              text: intl.formatMessage({
                id: 'Wrong diploma average. Please provide an avarage according to the type you have selected.',
              }),
              icon: 'error',
              confirmButtonText: intl.formatMessage({id: 'Okay'}),
            })
            .then((result) => {})
          return
        }

        // const response = await axios.put(`${API_URL_REAL}/Auth/UpdateApplicationUser`, values);

        // // Update local state with updated user data
        // setData(response.data);

        // if (selectedFile !== null) {

        //     await fileUploadHandler();
        // }
        // else {
        //     swal.fire({
        //         title: intl.formatMessage({
        //             id: 'Success'
        //         }),
        //         text: intl.formatMessage({ id: 'Kaydınız başarıyla tamamlandı.' }),
        //         icon: 'success',
        //         confirmButtonText: intl.formatMessage({ id: 'Okay' })
        //     }).then((result) => {
        //         if (result.isConfirmed) {
        //             navigate('/crafted/account/overview');
        //         }
        //     })
        // }

        try {
          const formData: any = new FormData()

          formData.append('id', values?.id)
          formData.append('name', values?.name)
          formData.append('surname', values?.surname)
          if (values?.password && values?.password !== '') {
            formData.append('password', values?.password)
          }

          if (values?.passportNumber && values?.passportNumber !== '') {
            formData.append('passportNumber', values?.passportNumber)
          } else {
            formData.append('passportNumber', '')
          }

          if (values?.identity && values?.identity !== '') {
            formData.append('identity', values?.identity)
          } else {
            formData.append('identity', '')
          }

          // formData.append('passportNumber', values?.passportNumber);
          formData.append('mothersName', values?.mothersName)
          formData.append('fathersName', values?.fathersName)
          formData.append('countryId', values?.countryId)
          formData.append('genderId', values?.genderId)
          formData.append('birthDate', values?.birthDate)
          formData.append('birthPlace', values?.birthPlace)
          formData.append('phone', values?.phone)
          formData.append('address', values?.address)
          // formData.append('diplomaAvarage', values?.diplomaAvarage);
          formData.append('diplomaAvarage', convertToCommaSeparated(values?.diplomaAvarage))
          formData.append('diplomaAvarageTypeId', values?.diplomaAvarageTypeId)
          formData.append('highSchoolCountryId', values?.highSchoolCountryId)
          formData.append('highSchoolStartDate', values?.highSchoolStartDate)
          formData.append('highSchoolFinishDate', values?.highSchoolFinishDate)
          formData.append('highSchoolName', values?.highSchoolName)
          formData.append('highSchoolType', values?.highSchoolType)
          formData.append('highSchoolCity', values?.highSchoolCity)
          formData.append('maritalStatusId', values?.maritalStatusId)
          formData.append('internationalDocumentTypeId', values?.internationalDocumentTypeId)
          if (values?.passportCountryId) {
            formData.append('passportCountryId', values?.passportCountryId)
          }
          if (values?.passportIssueDate) {
            formData.append('passportIssueDate', values?.passportIssueDate)
          }
          if (values?.passportIssuingAuthority) {
            formData.append('passportIssuingAuthority', values?.passportIssuingAuthority)
          }
          if (values?.passportExpirationDate) {
            formData.append('passportExpirationDate', values?.passportExpirationDate)
          }
          if (values?.blueCardIssueDate) {
            formData.append('blueCardIssueDate', values?.blueCardIssueDate)
          }
          // if (values?.blueCardExpirationDate) {
          //   formData.append('blueCardExpirationDate', values?.blueCardExpirationDate)
          // }
          if (values?.nationalIdNumber) {
            formData.append('nationalIdNumber', values?.nationalIdNumber)
          }
          if (values?.birthPlaceCountryId) {
            formData.append('birthPlaceCountryId', values?.birthPlaceCountryId)
          }

          if (RejectFile) {
            formData.append('rejectFile', RejectFile)
          }

          const response = await axios.put(`${API_URL_REAL}/Auth/UpdateApplicationUser`, formData)

          // Update local state with updated user data
          setData(response?.data)

          if (selectedFile !== null) {
            await fileUploadHandler()
          } else {
            swal
              .fire({
                title: intl.formatMessage({
                  id: 'Success',
                }),
                text: intl.formatMessage({id: 'Kaydınız başarıyla tamamlandı.'}),
                icon: 'success',
                confirmButtonText: intl.formatMessage({id: 'Okay'}),
              })
              .then((result) => {
                if (result.isConfirmed) {
                  navigate('/crafted/account/overview')
                }
              })
          }
        } catch (error: any) {
          if (error.response && error.response.data && error.response.data.message) {
            swal.close()
            const errorMessage = error.response.data.message
            swal.fire({
              title: intl.formatMessage({id: 'Error'}),
              text: intl.formatMessage({id: errorMessage}),
              icon: 'error',
              confirmButtonText: intl.formatMessage({id: 'Okay'}),
            })
          } else {
            swal.close()
            swal.fire({
              title: intl.formatMessage({id: 'Error'}),
              text: intl.formatMessage({id: 'Beklenmedik_Hata'}),
              icon: 'error',
              confirmButtonText: intl.formatMessage({id: 'Okay'}),
            })
          }
        }
      } catch (error) {
        console.error('Failed to update user data: ', error)
      } finally {
        setLoading(false)
      }
    },
  })

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    accept: {
      'image/jpg': ['.jpg'],
    }, // accept only JPEG images
    multiple: false, // accept only one file
  })

  const CountryWarning = (value: any) => {
    const country: any = countrys?.find((item: any) => item?.id == value)

    if (country) {
      if (lang === 'tr') {
        swal
          .fire({
            title: intl.formatMessage({id: 'Seçiminizi Onaylıyor musunuz?'}),
            text: intl.formatMessage({id: ` Seçilen Ülke : ${country?.name}`}),
            icon: 'warning', // İkonu 'warning' olarak değiştirdim, onay kutuları için daha uygun
            showCancelButton: true,
            confirmButtonText: intl.formatMessage({id: 'Yes'}),
            cancelButtonText: intl.formatMessage({id: 'No'}),
            allowOutsideClick: false, // Modal dışına tıklayarak çıkışı engelle
            allowEscapeKey: false, // ESC tuşu ile çıkışı engelle
          })
          .then((result) => {
            if (result.isConfirmed) {
              // Evet butonuna tıklandığında yapılacak işlemler

              formik.setFieldValue('countryId', value)
            } else if (result.dismiss === swal.DismissReason.cancel) {
              // Hayır butonuna tıklandığında yapılacak işlemler

              formik.setFieldValue('countryId', ' ')
            }
          })
      } else {
        swal
          .fire({
            title: intl.formatMessage({id: 'Do You Confirm Your Choice?'}),
            text: intl.formatMessage({id: `Selected country : ${country?.nameEn}`}),
            icon: 'warning', // İkonu 'warning' olarak değiştirdim, onay kutuları için daha uygun
            showCancelButton: true,
            confirmButtonText: intl.formatMessage({id: 'Yes'}),
            cancelButtonText: intl.formatMessage({id: 'No'}),
            allowOutsideClick: false, // Modal dışına tıklayarak çıkışı engelle
            allowEscapeKey: false, // ESC tuşu ile çıkışı engelle
          })
          .then((result) => {
            if (result.isConfirmed) {
              // Evet butonuna tıklandığında yapılacak işlemler

              formik.setFieldValue('countryId', value)
            } else if (result.dismiss === swal.DismissReason.cancel) {
              // Hayır butonuna tıklandığında yapılacak işlemler

              formik.setFieldValue('countryId', ' ')
            }
          })
      }
    } else {
      formik.setFieldValue('countryId', ' ')
    }
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_account_profile_details'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>{intl.formatMessage({id: 'Profile Details'})}</h3>
        </div>
      </div>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            <div className='alert alert-danger'>{intl.formatMessage({id: 'PhotoWarning'})}</div>
            <div className='row mb-6  mb-10'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'Photograph'})} (JPG)
              </label>
              <div className='col-lg-8'>
                <div
                  className='image-input image-input-outline'
                  data-kt-image-input='true'
                  style={{
                    backgroundImage: `url(${toAbsoluteUrl('/media/avatars/blank.png')})`,
                    marginLeft: '20px',
                  }}
                >
                  <div
                    className='image-input-wrapper w-125px h-175px'
                    style={{
                      backgroundImage: `url(${previewSrc})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }}
                  ></div>
                </div>
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <button type='button' className='btn btn-primary mt-2'>
                    {intl.formatMessage({id: 'Upload New Picture'})}
                  </button>
                </div>
              </div>
            </div>
            {currentUser?.idApproved !== '1' ? (
              <>
                {currentUser?.idApproved === '0' ? (
                  <div className='alert alert-danger'>{currentUser?.rejectionReason}</div>
                ) : (
                  <div className='alert alert-danger'>
                    {intl.formatMessage({
                      id: 'Please upload your passport photo. If you do not have a passport, please upload the other required documents.',
                    })}
                  </div>
                )}
                <div className='row mb-10 mt-5'>
                  <label className='col-lg-4 required col-form-label fw-bold fs-6'>
                    {intl.formatMessage({id: 'Identity Document'})} (JPG)
                  </label>
                  <div className='col-lg-8 fv-row mt-3'>
                    <input type='file' accept={'.jpg'} onChange={fileSelectedHandler} />
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
            {!!currentUser && currentUser?.isRejectFileRequired == 1 ? (
              <div className='row mb-10 mt-5'>
                <label className='col-lg-4 required col-form-label fw-bold fs-6'>
                  {intl.formatMessage({id: 'RejectFile'})} (PDF)
                </label>
                <div className='col-lg-8 fv-row mt-3'>
                  <input type='file' accept={'.PDF'} onChange={rejectFileSelectedHandler} />
                </div>
              </div>
            ) : (
              <></>
            )}

            <div className='alert alert-danger'>{intl.formatMessage({id: 'NameWarning'})}</div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'Name'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('name')}
                  type='text'
                  name='name'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.name && formik.errors.name},
                    {
                      'is-valid': formik.touched.name && !formik.errors.name,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.name && formik.errors.name && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.name}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'Surname'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('surname')}
                  type='text'
                  name='surname'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.surname && formik.errors.surname},
                    {
                      'is-valid': formik.touched.surname && !formik.errors.surname,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.surname && formik.errors.surname && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.surname}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'MothersName'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('mothersName')}
                  type='text'
                  name='mothersName'
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {'is-invalid': formik.touched.mothersName && formik.errors.mothersName},
                    {
                      'is-valid': formik.touched.mothersName && !formik.errors.mothersName,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.mothersName && formik.errors.mothersName && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.mothersName}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'FathersName'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('fathersName')}
                  type='text'
                  name='fathersName'
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {'is-invalid': formik.touched.fathersName && formik.errors.fathersName},
                    {
                      'is-valid': formik.touched.fathersName && !formik.errors.fathersName,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.fathersName && formik.errors.fathersName && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.fathersName}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'BirthDate'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('birthDate')}
                  type='date'
                  name='birthDate'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.birthDate && formik.errors.birthDate},
                    {
                      'is-valid': formik.touched.birthDate && !formik.errors.birthDate,
                    }
                  )}
                  autoComplete='off'
                  value={moment(formik.values.birthDate).format('YYYY-MM-DD')}
                  onChange={(e) => {
                    formik.setFieldValue('birthDate', new Date(e.target.value).toISOString())
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
                {formik.touched.birthDate && formik.errors.birthDate && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.birthDate}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'BirthPlaceCountry'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg'
                  {...formik.getFieldProps('birthPlaceCountryId')}
                  value={formik.values.birthPlaceCountryId}
                >
                  <option value=''>{intl.formatMessage({id: 'SEÇİNİZ'})}</option>
                  {countrys.map((myval: any) => (
                    <option value={myval.id} key={myval?.id as any}>
                      {lang === 'tr' ? (myval?.name as any) : (myval?.nameEn as any)}
                    </option>
                  ))}
                </select>
                {/* <div className='alert alert-danger mt-5'>
                  {intl.formatMessage({id: 'nationalityWarning'})}
                </div> */}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'BirthPlace'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('birthPlace')}
                  type='text'
                  name='birthPlace'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.birthPlace && formik.errors.birthPlace},
                    {
                      'is-valid': formik.touched.birthPlace && !formik.errors.birthPlace,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.birthPlace && formik.errors.birthPlace && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.birthPlace}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'InternationalDocType'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg'
                  {...formik.getFieldProps('internationalDocumentTypeId')}
                  value={formik.values.internationalDocumentTypeId}
                >
                  <option value=''>{intl.formatMessage({id: 'SEÇİNİZ'})}</option>
                  {internationalDocTypes.map((myval: any) => (
                    <option value={myval?.id} key={myval?.id as any}>
                      {lang === 'tr' ? (myval?.name as any) : (myval?.nameEn as any)}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className='alert alert-danger'>{intl.formatMessage({id: 'IdentityWarning'})}</div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label  fw-bold fs-6'>
                {intl.formatMessage({id: 'TC_YU_NUMBER'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('identity')}
                  type='text'
                  name='identity'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.identity && formik.errors.identity},
                    {
                      'is-valid': formik.touched.identity && !formik.errors.identity,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.identity && formik.errors.identity && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.identity}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='alert alert-danger'>
              {intl.formatMessage({id: 'NationalIdNumberWarning'})}
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label  fw-bold fs-6'>
                {intl.formatMessage({id: 'NationalIdNumber'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('nationalIdNumber')}
                  type='text'
                  name='nationalIdNumber'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {
                      'is-invalid':
                        formik.touched.nationalIdNumber && formik.errors.nationalIdNumber,
                    },
                    {
                      'is-valid':
                        formik.touched.nationalIdNumber && !formik.errors.nationalIdNumber,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.nationalIdNumber && formik.errors.nationalIdNumber && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.nationalIdNumber}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label  fw-bold fs-6'>
                {intl.formatMessage({id: 'PassportNumber'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('passportNumber')}
                  type='text'
                  name='passportNumber'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.passportNumber && formik.errors.passportNumber},
                    {
                      'is-valid': formik.touched.passportNumber && !formik.errors.passportNumber,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.passportNumber && formik.errors.passportNumber && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.passportNumber}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                {intl.formatMessage({id: 'PassportCountry'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg'
                  {...formik.getFieldProps('passportCountryId')}
                  value={formik.values.passportCountryId}
                >
                  <option value=''>{intl.formatMessage({id: 'SEÇİNİZ'})}</option>
                  {countrys.map((myval: any) => (
                    <option value={myval.id} key={myval?.id as any}>
                      {lang === 'tr' ? (myval?.name as any) : (myval?.nameEn as any)}
                    </option>
                  ))}
                </select>
                {/* <div className='alert alert-danger mt-5'>
                  {intl.formatMessage({id: 'nationalityWarning'})}
                </div> */}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                {intl.formatMessage({id: 'PassportIssueDate'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('passportIssueDate')}
                  type='date'
                  name='passportIssueDate'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {
                      'is-invalid':
                        formik.touched.passportIssueDate && formik.errors.passportIssueDate,
                    },
                    {
                      'is-valid':
                        formik.touched.passportIssueDate && !formik.errors.passportIssueDate,
                    }
                  )}
                  autoComplete='off'
                  value={moment(formik.values.passportIssueDate).format('YYYY-MM-DD')}
                  onChange={(e) => {
                    formik.setFieldValue(
                      'passportIssueDate',
                      new Date(e.target.value).toISOString()
                    )
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
                {formik.touched.passportIssueDate && formik.errors.passportIssueDate && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.passportIssueDate}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                {intl.formatMessage({id: 'PassportExpirationDate'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('passportExpirationDate')}
                  type='date'
                  name='passportExpirationDate'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {
                      'is-invalid':
                        formik.touched.passportExpirationDate &&
                        formik.errors.passportExpirationDate,
                    },
                    {
                      'is-valid':
                        formik.touched.passportExpirationDate &&
                        !formik.errors.passportExpirationDate,
                    }
                  )}
                  autoComplete='off'
                  value={moment(formik.values.passportExpirationDate).format('YYYY-MM-DD')}
                  onChange={(e) => {
                    formik.setFieldValue(
                      'passportExpirationDate',
                      new Date(e.target.value).toISOString()
                    )
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
                {formik.touched.passportExpirationDate && formik.errors.passportExpirationDate && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.passportExpirationDate}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label  fw-bold fs-6'>
                {intl.formatMessage({id: 'PassportIssuingAuthority'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('passportIssuingAuthority')}
                  type='text'
                  name='passportIssuingAuthority'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {
                      'is-invalid':
                        formik.touched.passportIssuingAuthority &&
                        formik.errors.passportIssuingAuthority,
                    },
                    {
                      'is-valid':
                        formik.touched.passportIssuingAuthority &&
                        !formik.errors.passportIssuingAuthority,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.passportIssuingAuthority && formik.errors.passportIssuingAuthority && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.passportIssuingAuthority}</div>
                  </div>
                )}
              </div>
            </div>
            <div className='alert alert-danger'>{intl.formatMessage({id: 'BlueCardWarning'})}</div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                {intl.formatMessage({id: 'BlueCardIssueDate'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('blueCardIssueDate')}
                  type='date'
                  name='blueCardIssueDate'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {
                      'is-invalid':
                        formik.touched.blueCardIssueDate && formik.errors.blueCardIssueDate,
                    },
                    {
                      'is-valid':
                        formik.touched.blueCardIssueDate && !formik.errors.blueCardIssueDate,
                    }
                  )}
                  autoComplete='off'
                  value={moment(formik.values.blueCardIssueDate).format('YYYY-MM-DD')}
                  onChange={(e) => {
                    formik.setFieldValue(
                      'blueCardIssueDate',
                      new Date(e.target.value).toISOString()
                    )
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
                {formik.touched.blueCardIssueDate && formik.errors.blueCardIssueDate && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.blueCardIssueDate}</div>
                  </div>
                )}
              </div>
            </div>

            {/* <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                {intl.formatMessage({id: 'BlueCardExpirationDate'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('blueCardExpirationDate')}
                  type='date'
                  name='blueCardExpirationDate'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {
                      'is-invalid':
                        formik.touched.blueCardExpirationDate &&
                        formik.errors.blueCardExpirationDate,
                    },
                    {
                      'is-valid':
                        formik.touched.blueCardExpirationDate &&
                        !formik.errors.blueCardExpirationDate,
                    }
                  )}
                  autoComplete='off'
                  value={moment(formik.values.blueCardExpirationDate).format('YYYY-MM-DD')}
                  onChange={(e) => {
                    formik.setFieldValue(
                      'blueCardExpirationDate',
                      new Date(e.target.value).toISOString()
                    )
                  }}
                />
                {formik.touched.blueCardExpirationDate && formik.errors.blueCardExpirationDate && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.blueCardExpirationDate}</div>
                  </div>
                )}
              </div>
            </div> */}

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'Email'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('email')}
                  type='text'
                  name='email'
                  disabled
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.email && formik.errors.email},
                    {
                      'is-valid': formik.touched.email && !formik.errors.email,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.email && formik.errors.email && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.email}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'Phone'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('phone')}
                  type='text'
                  name='phone'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.phone && formik.errors.phone},
                    {
                      'is-valid': formik.touched.phone && !formik.errors.phone,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.phone && formik.errors.phone && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.phone}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'Address'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('address')}
                  type='text'
                  name='address'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.address && formik.errors.address},
                    {
                      'is-valid': formik.touched.address && !formik.errors.address,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.address && formik.errors.address && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.address}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                {intl.formatMessage({id: 'Change Password'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('password')}
                  type='password'
                  name='password'
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {'is-invalid': formik.touched.password && formik.errors.password},
                    {
                      'is-valid': formik.touched.password && !formik.errors.password,
                    }
                  )}
                  autoComplete='new-password'
                />
                {formik.touched.password && formik.errors.password && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.password}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='alert alert-danger mt-5'>
              {intl.formatMessage({id: 'nationalityWarning'})}
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'Nationality'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg'
                  {...formik.getFieldProps('countryId')}
                  value={formik.values.countryId}
                  onChange={(e: any) => CountryWarning(e.target.value)}
                  disabled={true}
                >
                  <option value=''>{intl.formatMessage({id: 'SEÇİNİZ'})}</option>
                  {countrys.map((myval: any) => (
                    <option value={myval.id} key={myval?.id as any}>
                      {lang === 'tr' ? (myval?.name as any) : (myval?.nameEn as any)}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'Gender'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg'
                  {...formik.getFieldProps('genderId')}
                  value={formik.values.genderId}
                >
                  <option value=''>{intl.formatMessage({id: 'SEÇİNİZ'})}</option>
                  {genders.map((myval: any) => (
                    <option value={myval?.id} key={myval?.id as any}>
                      {lang === 'tr' ? (myval?.name as any) : (myval?.nameEn as any)}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'MaritalStatus'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg'
                  {...formik.getFieldProps('maritalStatusId')}
                  value={formik.values.maritalStatusId}
                >
                  <option value=''>{intl.formatMessage({id: 'SEÇİNİZ'})}</option>
                  {maritalStatus.map((myval: any) => (
                    <option value={myval?.id} key={myval?.id as any}>
                      {lang === 'tr' ? (myval?.name as any) : (myval?.nameEn as any)}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'HighSchoolName'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('highSchoolName')}
                  type='text'
                  name='highSchoolName'
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {'is-invalid': formik.touched.highSchoolName && formik.errors.highSchoolName},
                    {
                      'is-valid': formik.touched.highSchoolName && !formik.errors.highSchoolName,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.highSchoolName && formik.errors.highSchoolName && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.highSchoolName}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'HighSchoolType'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('highSchoolType')}
                  type='text'
                  name='highSchoolType'
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {'is-invalid': formik.touched.highSchoolType && formik.errors.highSchoolType},
                    {
                      'is-valid': formik.touched.highSchoolType && !formik.errors.highSchoolType,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.highSchoolType && formik.errors.highSchoolType && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.highSchoolType}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'HighSchoolStartDate'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('highSchoolStartDate')}
                  type='date'
                  name='highSchoolStartDate'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {
                      'is-invalid':
                        formik.touched.highSchoolStartDate && formik.errors.highSchoolStartDate,
                    },
                    {
                      'is-valid':
                        formik.touched.highSchoolStartDate && !formik.errors.highSchoolStartDate,
                    }
                  )}
                  autoComplete='off'
                  value={moment(formik.values.highSchoolStartDate).format('YYYY-MM-DD')}
                  onChange={(e) => {
                    formik.setFieldValue(
                      'highSchoolStartDate',
                      new Date(e.target.value).toISOString()
                    )
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
                {formik.touched.highSchoolStartDate && formik.errors.highSchoolStartDate && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.highSchoolStartDate}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'HighSchoolFinishDate'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('highSchoolFinishDate')}
                  type='date'
                  name='highSchoolFinishDate'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {
                      'is-invalid':
                        formik.touched.highSchoolFinishDate && formik.errors.highSchoolFinishDate,
                    },
                    {
                      'is-valid':
                        formik.touched.highSchoolFinishDate && !formik.errors.highSchoolFinishDate,
                    }
                  )}
                  autoComplete='off'
                  value={moment(formik.values.highSchoolFinishDate).format('YYYY-MM-DD')}
                  onChange={(e) => {
                    formik.setFieldValue(
                      'highSchoolFinishDate',
                      new Date(e.target.value).toISOString()
                    )
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
                {formik.touched.highSchoolFinishDate && formik.errors.highSchoolFinishDate && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.highSchoolFinishDate}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'HighSchoolCountry'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg'
                  {...formik.getFieldProps('highSchoolCountryId')}
                  value={formik.values.highSchoolCountryId}
                >
                  <option value=''>{intl.formatMessage({id: 'SEÇİNİZ'})}</option>
                  {countrys.map((myval: any) => (
                    <option value={myval?.id} key={myval?.id as any}>
                      {lang === 'tr' ? (myval?.name as any) : (myval?.nameEn as any)}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'HighSchoolCity'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('highSchoolCity')}
                  type='text'
                  name='highSchoolCity'
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {'is-invalid': formik.touched.highSchoolCity && formik.errors.highSchoolCity},
                    {
                      'is-valid': formik.touched.highSchoolCity && !formik.errors.highSchoolCity,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.highSchoolCity && formik.errors.highSchoolCity && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.highSchoolCity}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'DiplomaAvarageType'})}
              </label>
              <div className='col-lg-8 fv-row'>
                <select
                  className='form-select form-select-solid form-select-md'
                  {...formik.getFieldProps('diplomaAvarageTypeId')}
                  value={formik.values.diplomaAvarageTypeId}
                >
                  <option value=''>{intl.formatMessage({id: 'SEÇİNİZ'})}</option>
                  {diplomaavaragetypes.map((myval: any) => (
                    <option value={myval?.id} key={myval?.id as any}>
                      {lang === 'tr' ? (myval?.name as any) : (myval?.nameEn as any)}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'DiplomaAvarage'})}
              </label>
              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('diplomaAvarage')}
                  type='number'
                  name='diplomaAvarage'
                  className={clsx(
                    'form-control form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.diplomaAvarage && formik.errors.diplomaAvarage},
                    {
                      'is-valid': formik.touched.diplomaAvarage && !formik.errors.diplomaAvarage,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.diplomaAvarage && formik.errors.diplomaAvarage && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.diplomaAvarage}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className='card-footer d-flex justify-content-end py-6 px-9'>
              <button
                type='button'
                className='btn btn-primary'
                disabled={loading}
                onClick={formik.submitForm}
              >
                {!loading && intl.formatMessage({id: 'Save Changes'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {ProfileDetails}
